/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import "@fortawesome/fontawesome-svg-core/styles.css"
import { applyTheme, getStoredTheme } from "./src/utils/theme"

export const onClientEntry = () => {
  applyTheme(getStoredTheme())
}

// You can delete this file if you're not using it
